var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tabs',[_c('b-tab',{attrs:{"title":"Tabelle"}},[_c('tbl',{attrs:{"competition":_vm.competition}})],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Diagramm","lazy":true}},[(_vm.chartLoaded)?_c('chart',{attrs:{"chartData":_vm.chartData}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54c8df88","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/competitions/admin/Stats.vue
// module id = 1016
// module chunks = 1